module.exports = __webpack_public_path__ + "static/media/Saman.ac6d62a9.svg";